import { render, staticRenderFns } from "./DataTableBottomBar.vue?vue&type=template&id=310eb049&scoped=true&"
import script from "./DataTableBottomBar.vue?vue&type=script&lang=js&"
export * from "./DataTableBottomBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310eb049",
  null
  
)

export default component.exports